import React from "react";

const OtherHero = ({ title, content }) => {
  return (
    <div className="md:max-w-container max-w-containerSm mx-auto flex justify-between md:h-[733px] pb-[20px] md:pb-[45px] ">
      <div className="w-full pt-[46px] md:pt-[80px] text-white">
        <p className="text-[24px] md:text-[64px] font-bold font-firstFont">
          {title}
        </p>
        <div className="text-[14px] md:text-[16px] flex items-center mt-[4px] text-[#EBECEE]">
          <p>{content}</p>
        </div>
      </div>
    </div>
  );
};

export default OtherHero;
